import React from 'react';
import { Button, Form, Input, Modal, notification, Row, Select, Switch, Typography } from "antd";
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";

import ApiService from "../../../services/ApiService";
import PermissionAlert from "../../../components/permissions/PermissionAlert";

const { Search } = Input;
const { Text } = Typography;
const { Option } = Select;

export default class ModalAnniv extends React.Component {

    constructor(props) {
        super(props);
        props.getRef(this);
    }

    initialState = {
        visible: false,
        edit: true,
        loading: false,
        defaultData: {},
        contactId: null
    };

    state = this.initialState;

    show(contactId, data = {}) {
        this.setState({
            visible: true,
            edit: true,
            contactId: contactId,
            defaultData: { silence: true, ...data }
        });
    }

    close() {
        this.setState(this.initialState);
    }

    async onSubmit(data) {
        this.setState({ loading: true });

        var res = await ApiService.post("/contact/rappel/anniv/" + this.state.contactId, data);

        if (res.success) {
            notification.success({
                message: this.state.edit ? t`Modification réussie` : t`Ajout réussi`
            });

            this.close();
            if (this.props.onFinish) {
                this.props.onFinish();
            }
        } else {
            notification.error({
                message: this.state.edit ? t`Erreur lors de la modification` : t`Erreur lors de l’ajout`
            });
        }
    }

    render() {
        return (
            <Modal
                width="100%"
                title={this.state.edit ? t`Éditer un rappel d'anniversaire` : t`Ajouter un rappel d'anniversaire`}
                open={this.state.visible}
                destroyOnClose
                closable
                footer={null}
                onCancel={() => this.close()}
            >
                <PermissionAlert permissions={["contact.edit"]}>
                    <Form
                        ref={(ref) => this.form = ref}
                        initialValues={this.state.defaultData}
                        onFinish={(data) => this.onSubmit(data)}
                    >
                        <Form.Item
                            label={t`Uniquement Responsable`}
                            name="silence"
                            valuePropName={"checked"}
                        >
                            <Switch />
                        </Form.Item>

                        <Form.Item noStyle shouldUpdate>
                            {form => (
                                <Form.Item
                                    label={t`Texte libre`}
                                    name="text"
                                >
                                    <Input.TextArea
                                        disabled={form.getFieldValue("silence")}
                                        placeholder={t`N'oubliez pas...`}
                                        style={{ minHeight: "15vh" }}
                                    />
                                </Form.Item>
                            )}
                        </Form.Item>

                        <Form.Item style={{ display: "flex", justifyContent: "flex-end" }}>
                            <Button type="primary" htmlType="submit" loading={this.state.loading}>
                                <Trans>Valider</Trans>
                            </Button>
                        </Form.Item>
                    </Form>
                </PermissionAlert>
            </Modal>
        );
    }
}
